import React, { useState, useEffect } from 'react';
import {
  RootDiv,
  HeaderAppBar,
  HeaderToolbar,
  HeaderLeftDiv,
  PositionDivLeft,
  PositionDivRight,
  HeaderRightComponent,
  LoginButton,
  MekiLogoDiv,
} from './homeNavBar.styles';
import { DrawerMenu } from '@screens/menu';
import { MekiLogo } from '@components/icons/LogoMeki';
import { useRouter } from 'next/router';
import { getRoute, removeUndefineds } from '@utils';
import { useAuth } from '@hooks/useAuth';
import { useWindowSize } from '@hooks/useWindowSize';
import { DrawerCart } from '@screens/cart/DrawerCart';
import { useFocusSearchBox } from '@hooks/useFocusSearchBox';
import { SearchBox } from '@components/searchBox';
import { InteractionEventTypes } from '@validators/Events/Interactions';
import { useEventTracking } from '@hooks/useEventTracking';

interface HomeNavBarProps {
  isVisible: boolean;
  setIsVisible?: (isVisible: boolean) => void;
}

export function HomeNavBar({ isVisible, setIsVisible }: HomeNavBarProps) {
  const { width, isDesktop } = useWindowSize();
  const { track } = useEventTracking();
  const { appUser: user } = useAuth();
  const router = useRouter();
  const focusSearchBox = useFocusSearchBox();
  const [hideInfo, setHideInfo] = useState(false);
  const elevation = 1;

  useEffect(() => {
    if (isVisible && !isDesktop) {
      setHideInfo(true);
      return;
    }
    setHideInfo(false);
  }, [focusSearchBox, isVisible, isDesktop]);

  return (
    <RootDiv>
      <HeaderAppBar color="primary" elevation={elevation}>
        <HeaderToolbar>
          <PositionDivLeft>
            <HeaderLeftDiv>
              <DrawerMenu />
              {!hideInfo && (
                <MekiLogoDiv>
                  <MekiLogo
                    fill={'#414046'}
                    height="24px"
                    width="auto"
                    onClick={() => {
                      void router.push(getRoute('home'));
                    }}
                  />
                </MekiLogoDiv>
              )}
            </HeaderLeftDiv>
          </PositionDivLeft>

          <SearchBox
            isHeader={true}
            isVisible={isVisible}
            setIsVisible={setIsVisible}
          />

          <PositionDivRight>
            <HeaderRightComponent>
              {!hideInfo && (
                <>
                  {!user ? (
                    <LoginButton
                      size="medium"
                      onClick={() => {
                        void track(InteractionEventTypes.ClickLogin, {
                          location: 'navbar',
                        });
                        void router.push(
                          {
                            pathname: '/ingresar',
                            query: removeUndefineds({
                              ...router.query,
                            }),
                          },
                          {
                            pathname: '/ingresar',
                          },
                        );
                      }}
                    >
                      {width >= 1110 ? 'Iniciar sesión' : 'Inicia'}
                    </LoginButton>
                  ) : (
                    <DrawerMenu
                      isFromMenuName={`${user.name?.split(' ')[0]} ${
                        user.lastNames?.[0]?.toLocaleUpperCase() ?? ''
                      }.`}
                    />
                  )}
                </>
              )}

              {(isDesktop || (!isDesktop && !focusSearchBox.isFocus)) && (
                <DrawerCart />
              )}
            </HeaderRightComponent>
          </PositionDivRight>
        </HeaderToolbar>
      </HeaderAppBar>
    </RootDiv>
  );
}
